import type {
  NotificationItem,
  NotificationsApiAdapter,
} from "../../common/utils/useNotifications";
import { client } from "../api-client";
import {
  ApiV1ManagementNotificationsListInboxEnum,
  ApiV1ManagementNotificationsMarkAllAsReadPartialUpdateInboxEnum,
} from "../generated-axios-client";

// The bell leaves comments and reactions to the comment inbox next to it.
const managementNotificationsAdapter: NotificationsApiAdapter = {
  async fetchNotifications({ ordering, perPage }) {
    const response = await client.apiV1ManagementNotificationsList(
      undefined,
      ApiV1ManagementNotificationsListInboxEnum.General,
      undefined,
      ordering,
      perPage
    );
    return { data: { results: response.data.results as unknown as NotificationItem[] } };
  },

  async fetchUnreadCount() {
    const response = await client.apiV1ManagementMeRetrieve();
    return (
      (response.data.unread_notifications ?? 0) -
      (response.data.unread_comment_notifications ?? 0)
    );
  },

  async markAsRead(id) {
    return client.apiV1ManagementNotificationsMarkAsReadPartialUpdate(id);
  },

  async markAllAsRead(id) {
    return client.apiV1ManagementNotificationsMarkAllAsReadPartialUpdate(
      id,
      ApiV1ManagementNotificationsMarkAllAsReadPartialUpdateInboxEnum.General
    );
  },

  async deleteNotification(id) {
    return client.apiV1ManagementNotificationsDestroy(id);
  },
};

export { managementNotificationsAdapter };
